export default __webpack_public_path__ + "static/media/portadavideoanalisis3.98544961.png";